import { render, staticRenderFns } from "./ModalAddTabelaPrestador.vue?vue&type=template&id=58b68166"
import script from "./ModalAddTabelaPrestador.vue?vue&type=script&lang=ts"
export * from "./ModalAddTabelaPrestador.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports